import styled from "styled-components";

export const H1Styled = styled.h1`
  width: 80%;
  color: #000;
  font-size: 7rem;
  font-weight: bold;
  
  @media(max-width: 500px) {
    width: 100%;
    font-size: 6rem;
  }
`

export const H2Styled = styled.p`
  font-family: Travels, Helvetica, sans-serif;
  color: #000;
  font-size: 2rem;
  max-width: 100%;
`